import React from "react";
import {
  IconCalendar, IconArrowsRightLeft, IconSearch, IconHelpCircle,
} from "@tabler/icons-react";

const InsightsHeader = ({
  PRESETS, COMPARE_OPTIONS, preset, applyPreset,
  dateStart, dateEnd, setDateStart, setDateEnd,
  compareWith, setCompareWith,
  applyCustomDates, isDraftDirty,
  onOpenHelp,
}) => {
  const isCustom = preset === "custom";

  return (
    <div className="insights-header">
      <div className="insights-header__group">
        <label className="insights-header__label">
          <IconCalendar size={14} /> Período
        </label>
        <select
          className="insights-header__select"
          value={preset}
          onChange={(e) => applyPreset(e.target.value)}
        >
          {PRESETS.map((p) => (
            <option key={p.id} value={p.id}>{p.label}</option>
          ))}
        </select>
      </div>

      {isCustom && (
        <div className="insights-header__group insights-header__custom">
          <input
            type="date"
            className="insights-header__date"
            value={dateStart}
            onChange={(e) => setDateStart(e.target.value)}
          />
          <span className="insights-header__separator">até</span>
          <input
            type="date"
            className="insights-header__date"
            value={dateEnd}
            onChange={(e) => setDateEnd(e.target.value)}
          />
          <button
            type="button"
            className={`insights-header__search ${isDraftDirty ? "insights-header__search--pending" : ""}`}
            onClick={applyCustomDates}
            disabled={!isDraftDirty}
            title={isDraftDirty ? "Aplicar filtro" : "Sem alterações pendentes"}
          >
            <IconSearch size={14} />
            Buscar
          </button>
        </div>
      )}

      <div className="insights-header__group">
        <label className="insights-header__label">
          <IconArrowsRightLeft size={14} /> Comparar
        </label>
        <select
          className="insights-header__select"
          value={compareWith}
          onChange={(e) => setCompareWith(e.target.value)}
        >
          {COMPARE_OPTIONS.map((o) => (
            <option key={o.id} value={o.id}>{o.label}</option>
          ))}
        </select>
      </div>

      {onOpenHelp && (
        <button
          type="button"
          className="insights-header__help"
          onClick={onOpenHelp}
          title="Como interpretar as métricas"
        >
          <IconHelpCircle size={16} />
          Ajuda
        </button>
      )}
    </div>
  );
};

export default InsightsHeader;
